import { FC } from 'react'
import { AboutVisit } from '../../formComponents'

import { useVisitTypesList } from 'screens/Rostering/hooks/useVisitTypesList'

type AboutVisitSectionProps = {
  hideTeamMembers?: boolean
  hideAboutSection?: boolean
  formData?: Record<string, any> | undefined
  showTeamMembersSelect?: boolean
}

export const AboutVisitSection: FC<AboutVisitSectionProps> = ({
  hideTeamMembers,
  hideAboutSection,
  formData,
  showTeamMembersSelect = false,
}) => {
  const { visitTypes } = useVisitTypesList()

  const visitPresetPatternTypeOptions = visitTypes?.map((visit) => ({
    value: visit.id,
    label: visit.name,
  }))

  return (
    <AboutVisit
      typeOfVisitOptions={visitPresetPatternTypeOptions}
      hideTeamMembers={hideTeamMembers}
      hideAboutSection={hideAboutSection}
      showTeamMembersSelect={showTeamMembersSelect}
      formData={formData}
    />
  )
}
